<template>
    <el-dialog
        title="Añadir documento relacionado"
        width="50%"
        :visible="showDialog"
        @close="closeModal"
        @open="initForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
    >
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="control-label">
                        Nombre de la Empresa <span class="text-danger">*</span>
                    </label>
                    <el-input v-model="form.name"
                        :disabled="validateDisabled"></el-input>
                    <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <label class="control-label">
                    Tipo de documento <span class="text-danger">*</span>
                </label>
                <el-select v-model="form.document_type_id" placeholder="Tipo de documento"
                    filterable
                >
                  <el-option v-for="(type, index) in type_documents"
                    :label="type.description"
                    :value="type.id"
                    :key="index"></el-option>
                </el-select>
                <small v-if="errors.document_type_id" class="text-danger">{{ errors.document_type_id }}</small>
            </div>
            <div class="col-12 col-md-6">
                <label class="control-label">
                    Número RUC <span v-if="doc_validate.includes(form.document_type_id)"
                        class="text-danger">*</span>
                </label>
                <el-input v-model="form.ruc"
                    :disabled="validateDisabled"
                ></el-input>
                <small v-if="errors.ruc" class="text-danger">{{ errors.ruc }}</small>
            </div>
            <div class="col-12 col-md-6">
                <label class="control-label">
                    Serie de documento <span v-if="doc_validate.includes(form.document_type_id)"
                        class="text-danger">*</span>
                </label>
                <el-input v-model="form.serie"></el-input>
                <small v-if="errors.serie" class="text-danger">{{ errors.serie }}</small>
            </div>
            <div class="col-12 col-md-6">
                <label class="control-label">
                    Número de documento 
                    <template v-if="form.document_type_id === '50' || form.document_type_id === '52'">
                        <el-tooltip class="item"
                            effect="dark" placement="top">
                            <div slot="content">
                                <p v-if="form.document_type_id === '50'" style="color: #fff;">
                                    <span><strong>Régimen permitido:</strong> 40</span><br>
                                    <span><strong>Formato:</strong> {código de Aduana}-{año}-{código de régimen}-{número}</span><br>
                                    número no debe iniciar con cero<br>
                                    <span><strong>Ejemplo:</strong> 235-2022-40-75</span>
                                </p>
                                <p v-else style="color: #fff;">
                                    <span><strong>Régimen permitido:</strong> 48</span><br>
                                    <span><strong>Formato:</strong> {código de Aduana}-{año}-{código de régimen}-{número}</span><br>
                                    número no debe iniciar con cero<br>
                                    <span><strong>Ejemplo:</strong> 124-2023-48-75</span>
                                </p>
                            </div>
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </template>
                    <span class="text-danger">*</span>
                </label>
                <el-input v-model="form.number"></el-input>
                <small v-if="errors.number" class="text-danger">{{ errors.number }}</small>
            </div>
        </div>

        <template slot="footer">
            <el-button @click="closeModal">Cancelar</el-button>
            <el-button type="primary" @click="addDocument">Guardar</el-button>
        </template>
    </el-dialog>
</template>
<script>
    export default {
        props: ['showDialog','dispatch_type_id','datacompany','data_related', 'transfer_reason_type_id'],

        data() {
            return {
                form: {},
                type_documents: [],
                errors: {
                    name: null,
                    document_type_id: null,
                    ruc: null,
                    serie: null,
                    number: null
                },
                doc_validate: ['01', '03', '04', '09', '31']
            }
        },

        mounted() {
        },

        watch: {
            data_related(val) {
                this.assignTypeDocuments(val)
            },
            showDialog(value) {
                // this.completeInformation()
            },

            errors: {
                handler(value) {
                    if (value) {
                        setTimeout(() => {
                            this.errors = {
                                name: null,
                                document_type_id: null,
                                ruc: null,
                                serie: null,
                                number: null
                            }
                        }, 8000)
                    }
                },
                deep: true
            },

            // Observa cambios en form.name
            // 'form.name'(newVal) {
            //     if (!newVal) {
            //         this.errors.name = 'Completar este campo';
            //     } else {
            //         this.errors.name = null;
            //     }
            // },
            // // Observa cambios en form.document_type_id
            // 'form.document_type_id'(newVal) {
            //     if (!newVal) {
            //         this.errors.document_type_id = 'Seleccionar tipo de documento';
            //     } else {
            //         this.errors.document_type_id = null;
            //     }
            // },
            // // Observa cambios en form.ruc
            // 'form.ruc'(newVal) {
            //     if (this.doc_validate.includes(this.form.document_type_id)) {
            //         if (!newVal) {
            //             this.errors.ruc = 'Completar este campo';
            //         } else if (newVal.length !== 11) {
            //             this.errors.ruc = 'El RUC debe tener 11 dígitos';
            //         } else {
            //             this.errors.ruc = null;
            //         }
            //     }
            // },
            // // Observa cambios en form.serie
            'form.serie'(newVal) {
                if (this.doc_validate.includes(this.form.document_type_id)) {
                    if (!newVal) {
                        this.errors.serie = 'Completar este campo';
                    } else if (newVal.length !== 4) {
                        this.errors.serie = 'La serie debe tener 4 dígitos';
                    } else {
                        this.errors.serie = null;
                    }
                }
            },
            // // Observa cambios en form.number
            'form.number'(newVal) {
                if (this.form.document_type_id && !['50', '52'].includes(this.form.document_type_id)) {
                    if (!newVal) {
                        this.errors.number = 'Completar este campo';
                    } else if (!/^[0-9]+$/.test(newVal) && this.doc_validate.includes(this.form.document_type_id)) {
                        this.errors.number = 'Solo se permiten números';
                    } else {
                        this.errors.number = null;
                    }
                }
            },
        },

        computed: {
            hasErrors() {
                return Object.values(this.errors).some(element => element !== null)
            },

            validateDisabled() {
                if (this.transfer_reason_type_id === '02') { // compra
                    return false
                }
                return this.dispatch_type_id === '09' && this.doc_validate.includes(this.form.document_type_id)
            }
        },

        methods: {
            assignTypeDocuments(data) {
                this.type_documents = data.map(row => {
                    return {
                        id: row.code,
                        description: row.name
                    }
                })
            },
            initForm() {
                this.form = {
                    name: null,
                    document_type_id: null,
                    ruc: null,
                    serie: null,
                    number: null
                }

                this.errors = {
                    name: null,
                    document_type_id: null,
                    ruc: null,
                    serie: null,
                    number: null
                }

                if (this.dispatch_type_id === '09') {

                    this.completeInformation()
                }

                if (this.transfer_reason_type_id === '09') {
                    this.form.document_type_id = '50'
                }
            },

            async completeInformation() {
                if (this.datacompany) {
                    this.form.name = this.datacompany.name
                    this.form.ruc = this.datacompany.number
                }
            },

            validateForm() {
                let hasErrors = false

                // Validar name
                if (!this.form.name) {
                    this.errors.name = 'Completar este campo'
                    hasErrors = true
                }

                // Validar document_type_id
                if (!this.form.document_type_id) {
                    this.errors.document_type_id = 'Seleccionar tipo de documento'
                    hasErrors = true
                }

                if (this.doc_validate.includes(this.form.document_type_id)) {
                    // Validar RUC
                    if (!this.form.ruc) {
                        this.errors.ruc = 'Completar este campo'
                        hasErrors = true
                    } else if (this.form.ruc.length !== 11) {
                        this.errors.ruc = 'El RUC debe tener 11 dígitos'
                        hasErrors = true
                    }
    
                    // Validar serie
                    if (!this.form.serie) {
                        this.errors.serie = 'Completar este campo'
                        hasErrors = true
                    } else if (this.form.serie.length !== 4) {
                        this.errors.serie = 'La serie debe tener 4 dígitos'
                        hasErrors = true
                    }                    
                }

                // Validar number
                if (!this.form.number) {
                    this.errors.number = 'Completar este campo'
                    hasErrors = true
                } else if (!/^[0-9]+$/.test(this.form.number) && this.doc_validate.includes(this.form.document_type_id)) {
                    this.errors.number = 'Solo se permiten números'
                    hasErrors = true
                }

                return hasErrors
            },

            addDocument() {
                const formHasErrors = this.validateForm()
                if (formHasErrors) return

                let senddata = {
                    document_type: this.type_documents.find(t => t.id === this.form.document_type_id),
                    number: this.form.serie && this.form.number ? `${this.form.serie}-${this.form.number}` : this.form.number,
                    ruc: this.form.ruc,
                    name: this.form.name
                }

                this.$emit('addDocument', senddata)

                this.closeModal()
            },

            closeModal() {
                this.initForm()
                this.$emit('update:showDialog', false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/dispatches/partials/DocumentRelated.vue